import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from 'src/components';
import { Home, Handbook, HandbookCategory, HandbookSubCategory, HandbookSearch, ChatContainer, ChatWindow, MapContainer, 
    Profile, PrivacyPolicy, TermsOfService, PageNotFound, TrackingContainer, PublicTripsPortal, QrRedirect,
    Memberships, DeleteAccount, AdminPortal, PaymentStatusPage, ContactUs
} from 'src/pages';
import { useAuth } from 'src/utils';
import { Capacitor } from '@capacitor/core';

function AppRoutes(props) {

    const { user } = useAuth();
    const isNative = Capacitor.isNativePlatform();

    return (
        <Routes>

            {/*Home*/}
            <Route
                path="/"
                element={
                    isNative ? (
                    user && user.hasCompletedOnboarding ? 
                        <MapContainer footerHeight={props.footerHeight}/>
                        : <Profile />
                    ) : 
                    <Home />
                }/>

            {/*Handbook*/}
            <Route path='/handbook'
                element = {<Handbook setHandbookMenuTab={props.setHandbookMenuTab} />} />

            <Route path="/handbook/:category" 
                element={<HandbookCategory />} />

            <Route path="/handbook/:category/:slug" 
                element={<HandbookSubCategory />} />
            
            <Route path="/handbook/search" element={<HandbookSearch />} />

            {/*Chat*/}
            <Route path="/chat" 
                element={
                    <PrivateRoute>
                        <ChatContainer chats={props.userChats} chatUpdates={props.chatUpdates} loadingChats={props.loadingUserChats} footerHeight={props.footerHeight}/>
                    </PrivateRoute>}>

                <Route path="ai" element={<ChatWindow type="ai" userHasUnreadChats={props.userHasUnreadChats} />} />
                <Route path="direct/:userId" element={<ChatWindow type="direct" userHasUnreadChats={props.userHasUnreadChats} />} />
                <Route path="group/:groupId" element={<ChatWindow type="group" userHasUnreadChats={props.userHasUnreadChats} />} />
            </Route>
            
            {/*Tracking*/}
            <Route path='/trips'
                element = {<TrackingContainer footerHeight={props.footerHeight}/>}/>

            <Route path="/trips/all/:userId" 
                element={<PublicTripsPortal footerHeight={props.footerHeight}/>} />

            <Route path="/trips/:tripId/:userId" 
                element={<PublicTripsPortal footerHeight={props.footerHeight}/>} />

            {/*Map*/}
            <Route path='/map'
                element = {<MapContainer footerHeight={props.footerHeight}/>}/>

            {/*Profile*/}
            <Route path='/profile'
                element = {<Profile />}/>

            {/*Memberships*/}
            <Route path='/memberships'
                element = {<Memberships />}/>

            <Route path="/memberships/:status" 
                element={<PaymentStatusPage />} />

            {/*Privacy policy & Terms*/}
            <Route path='/privacy-policy'
                element = { <PrivacyPolicy />} />

            <Route path='/terms-of-service'
                element = { <TermsOfService />} />

            {/*Other*/}
            <Route path='/admin-portal'
                element = { <AdminPortal />} />

            <Route path='/qr'
                element = { <QrRedirect />} />

            <Route path='/qr/:source'
                element = { <QrRedirect />} />

            <Route path='/contact-us'
                element = { <ContactUs />} />

            <Route path='/delete-account'
                element = { <DeleteAccount />} />

            <Route path='*'
                element = { <PageNotFound />} />

        </Routes>
    )

}

export default AppRoutes;
